import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import actionTypes from "../../store/actions";
import Button from "../../component/button";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

class Admin extends Component {
  render() {
    let t = this.props.t;
    return (
      <main>
        <Grid container spacing={2}>
          <Grid
            item
            size={{
              xs: this.props.isCbizAdmin ? 6 : 12,
            }}
          >
            <Grid
              container
              justify="center"
              spacing={2}
              style={{ marginTop: "5%" }}
            >
              <Grid
                item
                align="center"
                size={{
                  xs: 12,
                }}
              >
                <h3>{t("ADD_NEW")}</h3>
              </Grid>
              <Grid
                item
                align="center"
                size={{
                  xs: 12,
                }}
              >
                <Link to="/providers/SALES_CHNL_PROVIDER">
                  <Button>{t("SALES_CHANNEL_PROVIDER")}</Button>
                </Link>
              </Grid>
              <Grid
                item
                align="center"
                size={{
                  xs: 12,
                }}
              >
                <Link to="/providers/SOLUTION_PROVIDER">
                  <Button>{t("SOLUTION_PROVIDER")}</Button>
                </Link>
              </Grid>
              <Grid
                item
                align="center"
                size={{
                  xs: 12,
                }}
              >
                <Link to="/providers/SERVICE_PROVIDER">
                  <Button>{t("SERVICE_PROVIDER")}</Button>
                </Link>
              </Grid>
            </Grid>
          </Grid>
          {this.props.isCbizAdmin && (
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Grid
                container
                justify="center"
                spacing={2}
                style={{ marginTop: "5%" }}
              >
                <Grid
                  item
                  align="center"
                  size={{
                    xs: 12,
                  }}
                >
                  <h3>{t("MANAGE")}</h3>
                </Grid>
                <Grid
                  item
                  align="center"
                  size={{
                    xs: 12,
                  }}
                >
                  <Link to="/manageSalesChannels">
                    <Button>{t("SALES_CHANNEL_PROVIDER")}</Button>
                  </Link>
                </Grid>
                <Grid
                  item
                  align="center"
                  size={{
                    xs: 12,
                  }}
                >
                  <Link to="/manageSolutionProviders">
                    <Button>{t("SOLUTION_PROVIDER")}</Button>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </main>
    );
  }
}

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    isCbizAdmin: state.auth.isCbizAdmin,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(Admin));
